import { Controller } from "@hotwired/stimulus"
import { formatNumeral } from "cleave-zen"

export default class extends Controller {
  static targets = ["display", "hidden"]

  connect() {
    const cents = parseInt(this.hiddenTarget.value) || 0
    if (cents !== 0) {
      this.displayTarget.value = this.centsToFormatted(cents)
    } else {
      this.displayTarget.value = ""
    }
  }

  format(event) {
    // Get raw input, remove anything that is not a digit
    const rawDigits = this.displayTarget.value.replace(/\D/g, "")
    
    // If empty string, set 0
    if (!rawDigits) {
      this.displayTarget.value = ""
      this.hiddenTarget.value = 0
      return
    }

    // Convert to number to remove leading zeros, then back to string
    let numericStr = parseInt(rawDigits, 10).toString()

    // Pad with zeros to ensure at least 3 digits (e.g. '1' -> '001')
    numericStr = numericStr.padStart(3, '0')

    // Split into integer and decimal parts
    const intPart = numericStr.slice(0, -2)
    const decPart = numericStr.slice(-2)

    // Assemble string with the correct numeralDecimalMark for cleave-zen
    const combined = `${intPart},${decPart}`

    // Format using cleave-zen
    const formatted = formatNumeral(combined, {
      numeralDecimalScale: 2,
      numeralDecimalMark: ',',
      delimiter: '.'
    })

    // Update display wrapper
    this.displayTarget.value = formatted

    // Update hidden field with raw cents
    this.hiddenTarget.value = parseInt(numericStr, 10)
  }

  centsToFormatted(cents) {
    const isNegative = cents < 0
    const absCents = Math.abs(cents)
    
    let numericStr = absCents.toString().padStart(3, '0')
    const intPart = numericStr.slice(0, -2)
    const decPart = numericStr.slice(-2)
    
    const combined = `${isNegative ? '-' : ''}${intPart},${decPart}`
    
    return formatNumeral(combined, {
      numeralDecimalScale: 2,
      numeralDecimalMark: ',',
      delimiter: '.'
    })
  }
}
